export default __webpack_public_path__ + "static/media/12_LeftToRightSquares_Top.0c3fd247.mp4";